<div class="driver-exercise-card">
    <div class="top-card">
        <div class="left-card" (click)="goToOperational()">
            <div class="text">
                <div class="title">
                    {{ operative()?.name }}
                    <mat-icon style="color:#2D3872">chevron_right</mat-icon>
                </div>
                <div class="subtitle">
                    @if(petitionCount() > 0){
                    <div class="petition">
                        <mat-icon>error</mat-icon>
                        <span>{{ petitionCount() }}</span>
                        {{ petitionMessage() }}
                    </div>
                    }@else{
                    <div class="no-petition">
                        No hay peticiones
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>

    <div class="bottom-card">
        <div class="bottom-information">
            @for(item of bottomItems(); track trackById($index, item)){
            <div class="info-item">
                <div class="subtitle">{{item.title}}</div>
                <div class="title">
                    @if(item.status === 'error'){
                    <mat-icon>error</mat-icon>
                    }@else if(item.status === 'success'){
                    <mat-icon id="check">check_circle</mat-icon>
                    }
                    {{item.value}}
                    @if(item.value2 !== undefined){
                    <span>/ {{item.value2}}</span>
                    }
                </div>
            </div>
            }
        </div>
    </div>
</div>